import React, { Component } from 'react';
import { connect } from 'react-redux';
import { fetchExtraFeedHome } from '../actions';
import translate from './TranslateHOC';
import { NOWNEXT_RELOAD_TIME } from '../constants';
import IsLoadingAnim from './alerts/IsLoadingAnim';
import { Card } from '../v2/components/card/Card';

import ExtraFeeds from './ExtraFeeds';

class NowNextAccurate extends Component {
  componentDidMount = (props) => {
    this.props.fetchExtraFeeds();
    this.extraFeedsTimer = setInterval(
      () => this.getExtraFeeds(),
      NOWNEXT_RELOAD_TIME
    );
  };

  UNSAFE_componentWillReceiveProps = (nextProps) => {
    if (nextProps.curLang !== this.props.curLang) {
      this.props.fetchExtraFeeds();
    }
  };

  componentDidUpdate = (prevProps) => {
    this.returnVal();
  };

  componentWillUnmount() {
    clearInterval(this.extraFeedsTimer);
  }

  getExtraFeeds() {
    this.props.fetchExtraFeeds();
  }

  returnVal = (props) => {
    if (this.props.getVal) {
      if (this.props.progNow) {
        this.props.getVal(this.props.progNow.programme_id);
      }
    }
  };

  isSelected = (pathName, e_url, c_url) => {
    if (pathName) {
      const slugTrim =
        pathName.substr(pathName.length - 1) === '/'
          ? pathName.substring(0, pathName.length - 1)
          : pathName;
      const slugArray = slugTrim.split('/');
      return slugArray[slugArray.length - 1] === e_url ||
        slugArray[slugArray.length - 1] === c_url
        ? true
        : false;
    }
  };

  render() {
    const {
      strings,
      progNow,
      progNext,
      extraFeeds,
      extraFeedsErrored,
      extraFeedsLoading,
    } = this.props;

    if (!progNow) {
      return <IsLoadingAnim />;
    }

    const localD = new Date();

    const ukD = localD.toLocaleString('en-GB', {
      timeZone: 'Europe/London',
    });

    const d = new Date(ukD);

    const nowInMins =
      parseInt(d.getHours(), 10) * 60 + parseInt(d.getMinutes(), 10);
    const endInMins =
      parseInt(this.props.progNow.end_txhour24, 10) * 60 +
      parseInt(this.props.progNow.end_txmin, 10);
    const timeLeft = endInMins - nowInMins;
    const nowLength =
      endInMins -
      parseInt(this.props.progNow.start_txhour24, 10) * 60 +
      parseInt(this.props.progNow.start_txmin, 10);
    const runTime = (100 / nowLength) * (nowLength - timeLeft);

    const progNowTitle =
      progNow.series_title === null || progNow.series_title === ''
        ? progNow.programme_title
        : progNow.programme_title === null || progNow.programme_title === ''
        ? progNow.series_title
        : progNow.series_title + ' - ' + progNow.programme_title;
    const progNextTitle =
      progNext.series_title === null || progNext.series_title === ''
        ? progNext.programme_title
        : progNext.programme_title === null || progNext.programme_title === ''
        ? progNext.series_title
        : progNext.series_title + ' - ' + progNext.programme_title;

    return (
      <div className="now-next-grid">
        <Card
          image={`https://www.s4c.cymru/amg/landscape/320x180/${progNow.thumbnail_url}`}
          isLive={true}
          subtitle={`${progNow.start_txhour24}.${progNow.start_txmin} - ${progNext.start_txhour24}.${progNext.start_txmin}`}
          tag={this.props.getVal ? strings.watching : strings.onNow}
          title={progNowTitle}
          url="/Live"
          progress={runTime}
          active={this.props.pathname === '/Live'}
          strings={strings}
        />
        <Card
          image={`https://www.s4c.cymru/amg/landscape/320x180/${progNext.thumbnail_url}`}
          onLater={true}
          subtitle={`${progNext.start_txhour24}.${progNext.start_txmin} - ${progNext.end_txhour24}.${progNext.end_txmin}`}
          tag={strings.onNext}
          title={progNextTitle}
          strings={strings}
        />

        {Object.keys(extraFeeds).length > 0 && (
          <ExtraFeeds
            items={extraFeeds}
            extraError={extraFeedsErrored}
            extraLoading={extraFeedsLoading}
            isSelected={this.isSelected}
            pathname={this.props.pathname}
          />
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    curLang: state.curLang,
    extraFeeds: state.extraFeedHomeItems.success,
    extraFeedsErrored: state.extraFeedHomeItems.error,
    extraFeedsLoading: state.extraFeedHomeItems.loading,
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    fetchExtraFeeds: () => dispatch(fetchExtraFeedHome()),
  };
};

export default translate(
  connect(mapStateToProps, mapDispatchToProps)(NowNextAccurate)
);
